module.exports = __webpack_public_path__ + "img/nav-appointment.379cc96.webp";